import { render, staticRenderFns } from "./payment_invoice.vue?vue&type=template&id=2072145a&scoped=true"
import script from "./payment_invoice.vue?vue&type=script&lang=js"
export * from "./payment_invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2072145a",
  null
  
)

export default component.exports